module.exports = __webpack_public_path__ + "img/delete-box-red.fa9ee290.svg";